<div class="heading" >
  Add business owner & incharge details
</div>
<div>
  <form [formGroup]="form" (ngSubmit)="submit()">
    <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
    <button type="submit" pButton class="btn btn-primary mt-6">Next <i class="pi pi-arrow-right arrow-icon" style="margin-left: 8px;"></i></button>
  </form>
</div>